import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Pagination from '../../Components/Pagination/Pagination';
import { handleApiCall } from '../../apis';
import { endpoint } from '../../utils/endpoints';
import { toast } from 'react-toastify';
import Toastify from '../../utils/tostfy';
import demppic from "../../assets/image/user-circle.svg"
import Loader from '../../Components/Loader/Loader';

function TeacherArea() {
    const navigate = useNavigate();
    const location = useLocation();
    console.log(location)
    const [totalPages, setTotalPages] = useState(0);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [search, setSearch] = useState("");
    const [indexNumber, setIndexNumber] = useState(0);
    const [user, setUser] = useState([]);

    // &search=${search}
    const getUserList = async () => {
        const response = await handleApiCall("get", `${endpoint.teacherArea}?page=${page}&limit=${perPage}&teacher_id=${encodeURIComponent(JSON.stringify(location?.state?.teacherIds))}`, {});
        try {
            if (response?.data?.code === 200) {
                setLoading(false)
                console.log(response, "school list")
                setUser(response?.data?.data?.teacherList);
                setTotalPages(response?.data?.data?.total_pages);
                setTotal(response?.data?.data?.total);
            }
            if (response?.response?.data?.success === false) {
                setLoading(false)
                toast.error(response?.response?.data?.errorMessage);
                setTimeout(() => { navigate("/") }, 2000);
            }
        } catch (e) {
            console.log("Error fetching data:", e);
        }
    };
    useEffect(() => {
        let timer;
        if (search) {
            setPage(1);
            setIndexNumber(0);
            setTotal(0);
            timer = setTimeout(() => {
                getUserList();
            }, 2000);
        } else {
            getUserList();
        }
        return () => {
            if (timer) clearTimeout(timer);
        };
    }, [page, search]);
    const paginationHandler = (e, i) => {
        e.preventDefault();
        if (i !== page) {
            setPage(i);
            const newIndexNumber = perPage * (i - 1);
            setIndexNumber(newIndexNumber);
        }
    };
    const [loading, setLoading] = useState(true)
    return (
        <>
            <Loader isLoading={loading} /> {/* Call Loader */}
            <div className=' imagebox image flex justify-between mb-3 items-center'>
                <div className=' flex gap-2 items-center'>
                    <img src={location?.state?.coachData?.image || demppic} alt="user" className="w-16 h-16 rounded-full" />
                    <div className=' flex-col'>
                        <p className=' font-bold '>  {location?.state?.coachData?.full_name} </p>
                        <p className=' text-gray-500'>Coach</p>

                    </div>

                </div>
                <div className=' '>
                    <Link onClick={() => navigate(-1)} className="text-white bg-black hover:text-white outline-1 outline-double rounded-md text-sm font-semibold px-4 py-2 d-inline-block">Back</Link>

                </div>
            </div>

            <div className="common-table-wrapper m-0">
                <div className="table-responsive">
                    <table>
                        <thead>
                            <tr>
                                <th>Sr.No.</th>
                                <th>Teacher<br />Name</th>
                                <th>Phone<br />Number</th>
                                <th>Email</th>

                                <th>School</th>
                                <th>School <br />Address</th>



                            </tr>
                        </thead>
                        <tbody>
                            {
                                user?.length > 0 ? user.map(({ _id, email, phone, school_name, school_address, full_name, image, country_code }, i) => {

                                    return (
                                        <tr key={_id}>
                                            <td>{indexNumber + i + 1}</td>
                                            <td>
                                                <div className="flex items-center gap-2 text-center mr-4">
                                                    <div className="w-[35px] h-[35px] rounded-full overflow-hidden flex-shrink-0">
                                                        <img
                                                            src={image || demppic}
                                                            alt={full_name || 'Profile'}
                                                            className="w-full h-full object-cover"
                                                        />
                                                    </div>
                                                    <span>{full_name || "-"}</span>
                                                </div>
                                            </td>
                                            <td>{country_code && phone ? `${country_code}-${phone}` : "-"}</td>
                                            <td>{email || "-"}</td>
                                            <td>{school_name || "-"}</td>
                                            <td>{school_address || "-"}</td>
                                        </tr>
                                    );
                                })
                                    :
                                    <tr className="justify-center">
                                        <td colSpan="100%">
                                            <h6 className=" text-center text-lg">No Request Found.</h6>
                                        </td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                </div>

                <Row className=" px-2 mb-4 py-2">
                    <Col md={12}>
                        <Pagination
                            data={user}
                            indexNumber={indexNumber}
                            totalPage={totalPages}
                            setPage={setPage}
                            page={page}
                            total={total}
                            paginationHandler={paginationHandler}
                        />
                    </Col>
                </Row>
            </div>

            <Toastify />

        </>
    )
}

export default TeacherArea